import React, { Fragment, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Slider, { createSliderWithTooltip } from 'rc-slider';

import { Label } from 'components/core/Label';
import { Paragraph } from 'components/core/Typography';

import './SliderInput.scss';

let sliderInputId = 0;

function getHelpText(helpTexts, value) {
	const index = Number.parseInt(value, 10) - 1;
	return helpTexts && index < helpTexts.length ? helpTexts[index] : null;
}

export const SliderInput = ({
	tooltip,
	id,
	label,
	helpTexts,
	error,
	onChange: onChangeProp,
	defaultValue,
	min,
	max,
	step,
}) => {
	sliderInputId += 1;
	const resolvedId = id ?? `ss-slider-input-${sliderInputId}`;
	const [helpText, setHelpText] = useState(() =>
		getHelpText(helpTexts, defaultValue),
	);

	const onChange = useCallback(
		(value) => {
			setHelpText(getHelpText(helpTexts, value));
			onChangeProp(value);
		},
		[helpTexts, onChangeProp],
	);

	const SInput = tooltip ? createSliderWithTooltip(Slider) : Slider;
	return (
		<Label
			htmlFor={resolvedId}
			text={label}
			className={classnames('ss-slider-input-label', { error })}
			render={(renderProps) => (
				<Fragment>
					<div className="slider-input">
						<SInput
							id={renderProps.id}
							min={min}
							max={max}
							step={step}
							defaultValue={defaultValue}
							onChange={onChange}
						/>
						{!!helpText && (
							<div className="help-text">{helpText}</div>
						)}
					</div>
					{error && (
						<Paragraph className="error-message">{error}</Paragraph>
					)}
				</Fragment>
			)}
		/>
	);
};

SliderInput.propTypes = {
	tooltip: PropTypes.bool,
	id: PropTypes.string,
	label: PropTypes.string,
	helpTexts: PropTypes.array,
	error: PropTypes.string,
	onChange: PropTypes.func,
	defaultValue: PropTypes.number,
	min: PropTypes.number,
	max: PropTypes.number,
	step: PropTypes.number,
};

export default SliderInput;
